"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var hammerjs_1 = __importDefault(require("hammerjs"));
var types_1 = require("./types");
function detectPanEvent(modifiers) {
    return modifiers.find(function (m) { return (0, types_1.isPanEvent)(m); }) || '';
}
function detectPinchEvent(modifiers) {
    return modifiers.find(function (m) { return (0, types_1.isPinchEvent)(m); }) || '';
}
function detectPressEvent(modifiers) {
    return modifiers.find(function (m) { return (0, types_1.isPressEvent)(m); }) || '';
}
function detectRotateEvent(modifiers) {
    return modifiers.find(function (m) { return (0, types_1.isRotateEvent)(m); }) || '';
}
function detectSwipeEvent(modifiers) {
    return modifiers.find(function (m) { return (0, types_1.isSwipeEvent)(m); }) || '';
}
function detectTapEvent(modifiers) {
    return modifiers.find(function (m) { return (0, types_1.isTapEvent)(m); }) || '';
}
function detectDoubleTapEvent(modifiers) {
    return modifiers.find(function (m) { return (0, types_1.isDoubleTapEvent)(m); }) || '';
}
var installer = {
    install: function (Vue, options) {
        Vue.directive('recognizer', {
            bind: function (el, binding) {
                var hammer = new hammerjs_1.default(el, options);
                var recognizer = binding.arg;
                var listener = binding.value;
                var modifiers = Object.keys(binding.modifiers);
                switch (recognizer) {
                    case types_1.Recognizer.Pan:
                        var panEvent = detectPanEvent(modifiers);
                        hammer.on("pan" + panEvent, listener);
                        break;
                    case types_1.Recognizer.Pinch:
                        var pinchEvent = detectPinchEvent(modifiers);
                        hammer.get('pinch').set({ enable: true });
                        hammer.on("pinch" + pinchEvent, listener);
                        break;
                    case types_1.Recognizer.Press:
                        var pressEvent = detectPressEvent(modifiers);
                        hammer.on("press" + pressEvent, listener);
                        break;
                    case types_1.Recognizer.Rotate:
                        var rotateEvent = detectRotateEvent(modifiers);
                        hammer.get('rotate').set({ enable: true });
                        hammer.on("rotate" + rotateEvent, listener);
                        break;
                    case types_1.Recognizer.Swipe:
                        var swipeEvent = detectSwipeEvent(modifiers);
                        hammer.on("swipe" + swipeEvent, listener);
                        break;
                    case types_1.Recognizer.Tap:
                        var tapEvent = detectTapEvent(modifiers);
                        hammer.on("tap" + tapEvent, listener);
                        break;
                    case types_1.Recognizer.DoubleTap:
                        var doubleTapEvent = detectDoubleTapEvent(modifiers);
                        hammer.on("doubletap" + doubleTapEvent, listener);
                        break;
                }
            }
        });
    }
};
exports.default = installer;
//# sourceMappingURL=index.js.map